import { IDjangoApi1License } from '../../tn.common';

export function hasWebFreeTrialLicense(
    licenses: IDjangoApi1License[]
): boolean {
    return licenses.some((license) => {
        return (
            license.fontRights.web &&
            license.fontRights.web.qty &&
            license.fontRights.web.years === -2
        );
    });
}
